<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		@if (showUploadControl()) {
		<input
			[ngClass]="inputDesignClass()"
			[ariaLabel]="title()"
			#inputFileElement
			(change)="onFilechange($event)"
			type="file"
			[placeholder]="placeholder()"
			autocomplete="off"
		/>
		} @else {
		<div libText3>{{ cannotUploadMoreFilesMessages() }}</div>
		}
	</div>

	<div slot="content">
		<div [class.push-top]="true">
			@if (cropFile() && imageCrop() ) { @if (file(); as file) { @if (imageCrop(); as imageCrop){
			<div>
				<lib-crop
					[imageToCrop]="file"
					[aspectRatio]="imageCrop.aspectRatio"
					[resizeToWidth]="imageCrop.resizeToWidth"
					[resizeToHeight]="imageCrop.resizeToHeight"
					[isUploading]="isUploading()"
					(imageCropped)="handleImageCropped($event)"
				></lib-crop>
			</div>
			} }} @if (isValid() && file() && !cropFile()) {
			<div class="push-bottom" libFlexRow [libFlexRowGap]="'16px'">
				<div libFlexColumn>
					<lib-button [buttonType]="'primaryLight'" (click)="handleUpload()">Upload file</lib-button>
				</div>

				@if (isUploading()) {

				<div libFlexColumn>
					<lib-loader [loaderType]="'spinner'"></lib-loader>
				</div>
				}
			</div>
			} @if (!standalone() && currentValue(); as fileReferences) { @if (fileReferences.length) {
			<div [libFlexRow]="true" [libFlexRowGap]="'16px'" class="push-top">
				@for (fileReference of fileReferences; track fileReference.absoluteUrl) {
				<div libFlexColumn [libFlexSize]="'150px'">
					<div>
						@if (fileReference.image) {
						<lib-image
							[alt]="'Uploaded file preview'"
							[isRound]="false"
							[isResponsive]="true"
							[image]="fileReference.image"
							[imageSize]="'250px'"
							[dialogPreviewImage]="fileReference.image"
						></lib-image>

						} @else {
						<div libLineClamp [clampLines]="2">
							{{ fileReference.originalFilename }}
						</div>
						}

						<div libFlexRow [libFlexRowAlign]="'center'" class="push-top-sm">
							<div libFlexColumn>
								<lib-button
									libConfirm
									(confirm)="removeFile(fileReference)"
									[confirmMode]="'delete'"
									[tooltip]="'Remove file'"
									[buttonType]="'basic'"
									[iconOnly]="true"
									[icon]="'delete'"
									[buttonSize]="'default'"
								></lib-button>
							</div>
						</div>
					</div>
				</div>
				}
			</div>
			} @else { @if (!file()) { @if (enableImageGallery()) {
			<ng-container>
				<ng-container>
					@if (imageGalleryDisplayMode() === 'inline' ) {

					<ui-select-item-field
						[mode]="'chips'"
						[placeholder]="'Select gallery'"
						[items]="galleryListItems()"
						[valueAsSignal]="activeGalleryValue"
						(selectedItemChange)="handleSetActiveGallery($event)"
					></ui-select-item-field>

					@if (activeGallery(); as activeGallery) {
					<div [libFlexRow]="true" class="push-top" [libFlexRowGap]="'24px'">
						@for(galleryItem of activeGallery.data; track galleryItem.id) {
						<div libFlexColumn [style.width]="calculateFlexWidth(imagesColumnsPerRow(), 24)">
							<div class="ui-gallery-item">
								<lib-image
									[imageSize]="'250px'"
									[alt]="'Gallery image'"
									[isResponsive]="true"
									[avatarName]="galleryItem.id"
									[image]="galleryItem.image"
									(click)="handleSelectGalleryItem(galleryItem)"
								></lib-image>
							</div>
						</div>
						}
					</div>
					} }</ng-container
				>
				@if (imageGalleryDisplayMode() === 'dialog') {
				<div>
					<lib-button-list
						[mode]="isMobileView() ? 'block' : 'list'"
						[buttons]="galleryButtons()"
					></lib-button-list>
				</div>
				}
			</ng-container>
			}

			<ng-container>
				@if (showNoFileUploadedMessage()) {
				<div class="push-top">
					<lib-message [type]="'info'">{{ noFileUploadedMessage() }}</lib-message>
				</div>
				}
			</ng-container>

			} } }
		</div>
	</div>
</ui-form-field-layout>
